import axios from "axios";
import { IGetReportsPayload } from "../models/report.model";

export const getReport = async (payload: IGetReportsPayload) => {
  const params: Record<string, string | number> = {
    page: payload.page,
    limit: payload.limit,
    keyword: payload.keyword,
    status: payload.status,
    direction_filter: payload.direction_filter,
  };
  if (payload.start_date) params.start_date = payload.start_date;
  if (payload.handled_by_ai) params.handled_by_ai = payload.handled_by_ai;
  if (payload.sort) {
    Object.entries(payload.sort).forEach(([key, value]) => {
      params[`sort[${key}]`] = value;
    });
  }

  const res = await axios.get("/reports", { params });
  return res;
};